export default __webpack_public_path__ + "static/media/gallery_05.76f7a615.jpg";